export default "__VITE_ASSET___T5RGnQ6__"